<template>
  <circle opacity="0.1" cx="27.5" cy="27.5001" r="27.5" fill="#4794F7" />
  <path
    d="M19 20C19 18.8954 19.8954 18 21 18H33C34.1046 18 35 18.8954 35 20V36C35 37.1046 34.1046 38 33 38H21C19.8954 38 19 37.1046 19 36V20Z"
    fill="#2E63D6"
  />
  <rect x="24" y="22" width="6" height="2" rx="1" fill="white" />
  <rect x="22" y="26" width="10" height="2" rx="1" fill="#92AFEA" />
  <rect x="22" y="30" width="10" height="2" rx="1" fill="#92AFEA" />
</template>
